<!-- 医院库Beta -->
<template>
  <div class="meeting-details">
    <!-- <div class="returnButton" @click="returnButton">
      <i class="el-icon-arrow-left"></i>
      返回
    </div> -->
    <div class="meeting-details-wrap" v-loading="isLoading">
      <div class="filter-bar">
        <el-form :inline="true" :model="form">
          <el-form-item label="会议类型:">
            <el-select
              v-model="form.type"
              placeholder="请选择"
              clearable
              @change="formChange({ key: 'type', value: form.type })"
            >
              <el-option
                v-for="item in meetingTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="会议产品:">
            <el-select
              v-model="form.product_ids"
              :clearable="true"
              multiple
              placeholder="请选择会议相关产品"
              @change="formChange({ key: 'product_ids', value: form.product_ids })"
            >
              <el-option
                v-for="item in productList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="地区:">
            <el-select
              v-model="form.province_code"
              :clearable="true"
              placeholder="省"
              style="margin-right: 12px"
              @change="formChange({ key: 'province_code', value: form.province_code })"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-select
              v-model="form.city_code"
              :clearable="true"
              placeholder="市"
              @change="formChange({ key: 'city_code', value: form.city_code })"
            >
              <el-option
                v-for="item in cityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <el-form inline>
          <el-form-item label="会议名称:">
            <el-input v-model="form.meeting_name" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="会议讲者:">
            <el-input v-model="form.speaker_name" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="查询时间:">
            <el-time-picker
              v-model="form.time"
              popper-class="time"
              is-range
              value-format="HH:mm:ss"
              :clearable="true"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            />
          </el-form-item>
        </el-form>
        <div class="button-group">
          <el-button type="primary" @click="clickToFilter">筛选</el-button>
          <ExportExcel
            config-name="MeetingDataByOneDay"
            :excel-data="excelData"
            :is-loading="isExportLoading"
            @emit="handleExportExcel"
          ></ExportExcel>
        </div>
      </div>
      <div class="meeting-table-wrap">
        <el-table class="my-table" :data="tableData">
          <template slot="empty">
            <!-- 没有数据 -->
            <NoData></NoData>
          </template>
          <el-table-column prop="meeting_name" label="会议名称" />
          <el-table-column prop="start_time" label="会议开始时间" width="120">
            <template slot-scope="scope">
              {{ dateFormat(new Date(scope.row.start_time * 1000), 'HH:mm') }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="会议类型">
            <template slot-scope="scope">{{ renderMeetingTypeName(scope.row.type) }}</template>
          </el-table-column>
          <el-table-column prop="product_name" label="相关产品">
            <template slot-scope="scope">
              <span v-for="(product, index) in scope.row.product_name" :key="index">
                {{ `${product} ` }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="duration" label="会议时长(min)" width="120">
            <template slot-scope="scope">
              {{ formatMinsToHour(scope.row.duration) }}
            </template>
          </el-table-column>
          <el-table-column prop="attending_num" label="参会人数" />
          <el-table-column prop="speaker_name" label="讲者姓名" />
          <el-table-column prop="applier_name" label="申请人姓名" width="120"></el-table-column>
          <el-table-column prop="sync_attendance_time" label="同步时间">
            <template slot-scope="scope">
              {{ dateFormat(new Date(scope.row.sync_attendance_time * 1000), 'HH:mm:SS') }}
            </template>
          </el-table-column>
          <el-table-column prop="state" width="" label="是否完成">
            <template slot-scope="scope">{{ !!scope.row.state ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="is_violate" label="是否合规">
            <template slot-scope="scope">
              {{ !!scope.row.is_violate ? '否' : '是' }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="clickToDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination"
          style="background-color: #ffffff"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="g_pageSizesConfig"
          :total="total"
          :page-size="pagination.page_size"
          :current-page="pagination.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils/time.js';
import {
  getMeetingListApi, // 会议明细列表
} from '@/api/dataCenter.js';
import { getAreaList } from '@/api/setUp';
import { formatMinsToHour } from '@/utils/util';
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
export default {
  name: 'MeetingDetails',
  components: {
    NoData,
    ExportExcel,
  },
  props: {},
  data() {
    return {
      isLoading: false,
      meetingDate: '', // 路由传过来的数据
      form: {
        type: '',
        product_ids: [],
        province_code: '',
        city_code: '',
        time: '', // 查询时间
        meeting_name: '',
        speaker_name: '',
      },
      total: 0,
      pagination: {
        page_size: this.g_pageSizeDefault,
        page_index: 1,
      },
      tableData: [],
      dateFormat,
      formatMinsToHour,
      cityList: [],
      excelData: [],
      isExportLoading: false,
    };
  },
  computed: {
    meetingTypeOptions() {
      return this.$store.state.meetingData.meetingTypeOptions;
    },
    productList() {
      return this.$store.state.meetingData.productList;
    },
    provinceList() {
      return this.$store.state.meetingData.provinceList;
    },
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.pagination.page_size = this.g_pageSizeDefault;
    this.meetingDate = this.$route.query.date;
    this.getTableList();
    this.$store.dispatch('meetingData/getProductList');
    this.$store.dispatch('meetingData/getMeetingTypeList');
    this.$store.dispatch('meetingData/getProvinceData');
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    clickToDetail(row) {
      this.g_tourl(
        `/saas/meetingData/meetingOrganizersDetail.html?date=${this.meetingDate}&meetingId=${row.meeting_id}`,
        {
          open: true,
        },
      );
    },
    // 获取会议类型名称
    renderMeetingTypeName(value) {
      const index = this.meetingTypeOptions.findIndex((i) => i.value === value);
      if (index !== -1) {
        return this.meetingTypeOptions[index].label;
      }
      return '--';
    },
    formChange({ key, value }) {
      if (key === 'province_code') {
        this.form.city_code = '';
        this.getCityData(value);
      }
    },
    async getCityData(area_code = '') {
      if (this.form.province_code === '') {
        this.cityList = [];
        return;
      }
      try {
        const res = await getAreaList({
          area_code,
          type: 'City',
        });

        this.cityList = res.data.map((item) => ({
          label: item.area_name,
          value: item.area_code,
        }));
      } catch (err) {
        console.log('error', err);
      }
    },
    /*
     * 获取表格数据
     */
    async getTableList() {
      this.isLoading = true;
      const params = {
        date: this.meetingDate,
        // date: '',
        province_code: this.form.province_code,
        city_code: this.form.city_code,
        start_time: this.form.time?.length
          ? new Date(`${this.meetingDate} ${this.form.time[0]}`).getTime() / 1000
          : '',
        end_time: this.form.time?.length
          ? new Date(`${this.meetingDate} ${this.form.time[1]}`).getTime() / 1000
          : '',
        ...this.pagination,
        product_ids: this.form.product_ids,
        type: this.form.type || 0,
        meeting_name: this.form.meeting_name,
        speaker_name: this.form.speaker_name,
      };
      try {
        const res = await getMeetingListApi(params);
        this.tableData = res.data;
        this.total = res.total_num;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
        this.$message.error(`查询会议详情列表失败 ${err.message || ''}`);
        console.log('error', err);
      }
      this.isLoading = false;
    },
    async handleExportExcel() {
      this.isExportLoading = true;
      const params = {
        date: this.meetingDate,
        // date: '',
        province_code: this.form.province_code,
        city_code: this.form.city_code,
        start_time: this.form.time?.length
          ? new Date(`${this.meetingDate} ${this.form.time[0]}`).getTime() / 1000
          : '',
        end_time: this.form.time?.length
          ? new Date(`${this.meetingDate} ${this.form.time[1]}`).getTime() / 1000
          : '',
        page_index: 1,
        page_size: 9999,
        product_ids: this.form.product_ids,
        type: this.form.type || 0,
        meeting_name: this.form.meeting_name,
        speaker_name: this.form.speaker_name,
      };
      try {
        const res = await getMeetingListApi(params);
        console.log('列表数据', res);
        this.excelData = res.data.map((item) => {
          const items = { ...item };
          items.start_time = this.dateFormat(new Date(item.start_time * 1000), 'HH:mm');
          items.type = this.renderMeetingTypeName(item.type);
          items.duration = this.formatMinsToHour(item.duration);
          items.sync_attendance_time = this.dateFormat(
            new Date(item.sync_attendance_time * 1000),
            'HH:mm:SS',
          );
          items.product_name = items.product_name.join(' ');
          items.state = !!item.state ? '是' : '否';
          items.is_violate = !item.is_violate ? '是' : '否';
          return items;
        });
      } catch (err) {
        this.excelData = [];
        console.log('error', err);
      }
      this.isExportLoading = false;
    },
    clickToFilter() {
      this.pagination.page_index = 1;
      this.getTableList();
    },
    /*
     * 切换页码
     */
    handleCurrentChange(val) {
      this.pagination.page_index = val;
      this.getTableList();
    },
    handleSizeChange(size) {
      this.pagination.page_size = size;
      this.getTableList();
    },
  },
};
</script>
<style lang="scss" scoped>
.meeting-details {
  background: #f7f9fc;
  .returnButton {
    background-color: #fff;
    padding-bottom: 20px;
    cursor: pointer;
  }
  .meeting-details-wrap {
    background-color: #fff;
    // margin-top: 24px;
    .filter-bar {
      border-bottom: 1px solid #f0f1f4;
      padding: 24px 0;
      .button-group {
        display: flex;
        justify-content: flex-end;
      }
    }
    .pagination {
      float: right;
      margin-top: 12px;
    }
  }
}
</style>
